<template>
  <f7-page login-screen class="login-page">
    <div class="login-hero">
      <f7-icon
        ios="f7:lock_shield"
        md="material:password"
        class="login-hero-icon"
        color="primary"
      />
      <f7-login-screen-title>Nové heslo</f7-login-screen-title>
    </div>

    <f7-card class="login-card">
      <f7-card-content>
        <f7-block-header class="margin-bottom">
          <p>Zadajte svoje nové heslo.</p>
        </f7-block-header>

        <form @submit.prevent="updatePassword">
          <f7-list dividers-ios no-hairlines class="no-margin">
            <f7-list-input
              v-model:value="password"
              label="Nové heslo"
              type="password"
              placeholder="Zadajte nové heslo"
              @keydown.enter.prevent="focusConfirmation"
            />
            <f7-list-input
              ref="confirmationInput"
              v-model:value="confirmPassword"
              label="Overenie hesla"
              type="password"
              placeholder="Zopakujte nové heslo"
              @keydown.enter.prevent="
                ;($event.target as HTMLElement)?.blur()
                updatePassword()
              "
            />
          </f7-list>
        </form>
        <f7-button large tonal color="secondary" class="margin-top" @click="updatePassword"
          >Uložiť nové heslo</f7-button
        >
      </f7-card-content>
    </f7-card>
  </f7-page>
</template>
<script setup lang="ts">
import { f7 } from 'framework7-vue'
import { ref } from 'vue'

import { runReportedAction } from '@/assets/composables/diagnostics'
import { updateUserPassword } from '@/assets/composables/endpoints'

const emit = defineEmits<{ done: [] }>()

const password = ref<string>('')
const confirmPassword = ref<string>('')
const confirmationInput = ref<any>(null)
const loading = ref<boolean>(false)

const focusConfirmation = () => {
  confirmationInput.value?.$el?.querySelector('input')?.focus()
}

const updatePassword = async () => {
  if (loading.value) return

  if (password.value === '' || confirmPassword.value === '') {
    f7.dialog.alert('Vyplňte prosím obe polia.')
    return
  }

  if (password.value !== confirmPassword.value) {
    f7.dialog.alert('Heslá sa nezhodujú.')
    return
  }

  if (password.value.length < 6) {
    f7.dialog.alert('Heslo musí mať aspoň 6 znakov.')
    return
  }

  loading.value = true
  f7.preloader.show()

  const succeeded = await runReportedAction(() => updateUserPassword(password.value), {
    area: 'auth',
    operation: 'password-update',
    endpoint: '/auth/v1/user',
    title: 'Heslo sa nepodarilo uložiť',
    message:
      'Heslo sa nepodarilo uložiť. Skontrolujte požiadavky na nové heslo alebo skúste to prosím neskôr.',
  })

  if (!succeeded) {
    loading.value = false
    f7.preloader.hide()
    return
  }

  ;(document.activeElement as HTMLElement)?.blur()
  emit('done')
}
</script>

<style scoped>
.login-page {
  --f7-login-screen-title-font-size: 28px;
  --f7-login-screen-title-font-weight: 700;
}

.login-hero {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 10vh;
  padding-bottom: 24px;
}

.login-hero-icon {
  font-size: 56px;
  margin-bottom: 8px;
}

.login-card {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
}

.login-card :deep(.item-content.item-input) {
  margin-left: 0;
  margin-right: 0;
}
</style>
